import { Component } from '@angular/core';
import { ZendeskWidgetService } from '@netfoundry-ui/shared/services';

@Component({
    selector: 'app-form-support-button',
    templateUrl: './form-support-button.component.html',
    styleUrls: ['./form-support-button.component.scss'],
    standalone: false
})
export class FormSupportButtonComponent {
    constructor(private zendeskService: ZendeskWidgetService) {}

    openSupport() {
        this.zendeskService.zE('webWidget', 'show');
        this.zendeskService.zE('webWidget', 'open');
    }
}
